import Subscribe from "components/Subscribe";
import type { SubscribeProps } from "components/Subscribe/Subscribe.d";
import type { ReactStoryblokComponent } from "types/storyblok";

const SubscribeAdapter = ({ blok: { heading, text, buttonText, listId } }: ReactStoryblokComponent<SubscribeProps>) => (
  <Subscribe heading={heading} text={text} buttonText={buttonText} listId={listId} />
);

export default SubscribeAdapter;
